// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Sint Maarten */
const SX = /^(?:7215(?:1[02]|2\d|5[034679]|8[0-24-8])\d{4})$/;

export default SX;
